import { isPlatformBrowser } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import {
  APP_INITIALIZER,
  Optional,
  PLATFORM_ID,
  Provider,
} from '@angular/core';
import { REQUEST } from '@nguniversal/express-engine/tokens';
import {
  MissingTranslationHandler,
  MissingTranslationHandlerParams,
  TranslateLoader,
  TranslateModule,
  TranslateService,
} from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

export function getLangFromUrl(platformId: object, request?: Request): string {
  if (isPlatformBrowser(platformId)) {
    const segment = window.location.pathname.split('/')[1];
    if (segment === 'en' || segment === 'de') {
      return segment;
    }
    return 'pl';
  } else {
    const url = request?.url || '';
    const segment = url.split('/')[1];
    if (segment === 'en' || segment === 'de') {
      return segment;
    }
    return 'pl';
  }
}

export function appTranslateInitializer(
  translate: TranslateService,
  platformId: object,
  request?: Request
) {
  return () => {
    const lang = getLangFromUrl(platformId, request);
    translate.setDefaultLang(lang);
    translate.use(lang);
  };
}

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, '/assets/i18n/', '.json');
}

export class CustomMissingTranslationHandler
  implements MissingTranslationHandler
{
  handle(params: MissingTranslationHandlerParams) {
    return params.key;
  }
}

export const provideTranslations: Provider[] = [
  TranslateService,
  TranslateModule.forRoot({
    useDefaultLang: true,
    missingTranslationHandler: {
      provide: MissingTranslationHandler,
      useClass: CustomMissingTranslationHandler,
    },
    loader: {
      provide: TranslateLoader,
      useFactory: HttpLoaderFactory,
      deps: [HttpClient],
    },
  }).providers!,
  {
    provide: APP_INITIALIZER,
    useFactory: appTranslateInitializer,
    deps: [TranslateService, PLATFORM_ID, [new Optional(), REQUEST]],
    multi: true,
  },
];
